import AuthConstants from './AuthConstants';

const defaultState = {
    id: undefined
}

export function auth(state = defaultState, action) {
    switch (action.type) {
        case AuthConstants.AUTH_LOGGED_IN:
            return {
                id: action.payload.id,
                name: action.payload.name,
                email: action.payload.email
            };
        case AuthConstants.AUTH_LOGGED_OUT:
            return defaultState;
        default:
            return state;
    }
}
